import Decimal from "decimal.js";

export const CustomDecimal = Decimal.set({
  rounding: Decimal.ROUND_DOWN,
});

export const convertToDecimal = (
  value: string | number | null | undefined,
): Decimal => {
  return new CustomDecimal(value ? value : "0");
};
